<template>
  <div class="column">
    <app-button
      v-bind="$attrs"
      :styles="{ backgroundColor: buttonColor }"
      class="main-button"
      :class="{ 'no-value': !buttonColor }"
      :label="label"
      :disable="disableComputed || readonlyComputed"
      @click="localVisible = !localVisible"
    />
    <app-dialog v-if="localVisible" @ok="onClose" @cancel="localVisible = false">
      <template #content>
        <q-color v-model="localColor" />
      </template>
      <template #actions>
        <app-button outline :label="$t('_RSFAP_SHARED_FILTERS_CLEAR')" @click="clearColor" />
      </template>
    </app-dialog>
  </div>
</template>

<script setup>
import { ref, watch } from "vue"

import { useFieldsetState } from "@/composables/useFieldsetState.js"

defineOptions({ inheritAttrs: false })

const props = defineProps({
  modelValue: String,
  label: String,
  disable: Boolean
})

const { disableComputed, readonlyComputed } = useFieldsetState(props)

const emit = defineEmits(["update:model-value"])

const localColor = ref(props.modelValue)
const localVisible = ref(false)
const buttonColor = ref(props.modelValue)

watch(
  () => props.modelValue,
  (newValue) => {
    localColor.value = newValue
    buttonColor.value = newValue
  }
)

const onClose = () => {
  emit("update:model-value", localColor.value)
  buttonColor.value = localColor.value
  localVisible.value = false
}

const clearColor = () => {
  localColor.value = null
  buttonColor.value = null
  emit("update:model-value", null)
  localVisible.value = false
}
</script>

<style lang="scss" scoped>
.main-button {
  text-shadow: 1px 1px rgba(0, 0, 0, 0.5), -1px 1px rgba(0, 0, 0, 0.5), 1px -1px rgba(0, 0, 0, 0.5), -1px -1px rgba(0, 0, 0, 0.5);

  &.no-value {
    background-image: linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(135deg, #ccc 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(135deg, transparent 75%, #ccc 75%);
    background-size: 25px 25px;
    background-position: 0 0, 12.5px 0, 12.5px -12.5px, 0px 12.5px;
  }
}
</style>
